module.exports = __webpack_public_path__ + "img/no-message1.7b47c79b.png";